import { applyMiddleware, createStore } from "redux";
import thunk from "redux-thunk";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import AllReducer from "./reducers/index";
import { CLEAR_STORAGE } from "../constants/appConstants";
import { TypedUseSelectorHook } from "react-redux";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = (state: any, action: any) => {
  if (action.type === CLEAR_STORAGE) {
    storage.removeItem("persist:root");
    return AllReducer(undefined, action);
  }
  return AllReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// const persistedReducer = persistReducer(persistConfig, AllReducer);
let store = createStore(persistedReducer, applyMiddleware(thunk));
let persistor = persistStore(store);


export { store, persistor };

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
store.subscribe(() => { process.env.NODE_ENV === "development" && console.log(store.getState()) })
